import React from 'react'
import _ from 'lodash'
import { useQuery } from '@apollo/client'
import Loading from '../../../Loading'
import Error from '../../../Error'
import readingTypesQuery from '../../../ReadingTypes/List/Items/lib/query'
import unitsQuery from '../../../Units/List/Items/lib/query'
import Group from '../../../Rules/Form/Group'
import Description from '../../../Input/Description'
import RelationListInput from '../../../Input/RelationList'
import Label from './Label'
import onNew from './lib/onNew'

export default ({
  formikProps: {
    values: { modelId },
  },
  formikProps,
}) => {
  if (!modelId) return null

  const readingTypesQueryProps = useQuery(readingTypesQuery)
  const unitsQueryProps = useQuery(unitsQuery)

  if (readingTypesQueryProps.loading || unitsQueryProps.loading)
    return <Loading />
  if (readingTypesQueryProps.error || unitsQueryProps.error) return <Error />

  return (
    <Group label='Reading offsets'>
      <Description>Offset reading values for this sensor.</Description>

      <RelationListInput
        path='readingOffsets'
        query={readingTypesQuery}
        variables={{
          filter: {
            type: 'Float',
            modelId,
          },
        }}
        queryPath='readingTypes'
        formikProps={formikProps}
        header='Reading type'
        onNew={onNew}
        getKey={({ item: { readingTypeId } }) => readingTypeId}
        onDeleteProps={{ style: { marginTop: '10px' } }}
        isSelected={({ item: { id }, values }) =>
          _.some(values, { readingTypeId: id })
        }
        label={({ item, index }) => (
          <Label
            item={item}
            index={index}
            readingTypesQueryProps={readingTypesQueryProps}
            unitsQueryProps={unitsQueryProps}
            formikProps={formikProps}
          />
        )}
      />
    </Group>
  )
}
